module.exports = __webpack_public_path__ + "img/8.129b6ee3.png";